const getDefaultState = () => {
  return {
    offline: false, // whether user is connected to the internet or not

    disconnected: false,
    reconnecting: false,
    connected: true,

    statusMessage: "",
    statusVisible: false,

    partnerDisconnected: false,
    partnerReconnecting: false,
    partnerConnected: false,
    partnerLeft: false,
    partnerStuckAtLoading: false,

    partnerStatusMessage: "",
    partnerStatusVisible: false,
  };
};

const state = getDefaultState();

const STATUS_MESSAGES = {
  disconnected: "You were disconnected. Reconnecting...",
  reconnecting: "You were disconnected. Reconnecting...",
  connected: "Successfully reconnected.",

  partnerDisconnected: "Your partner got disconnected.",
  partnerReconnecting: "Your partner is reconnecting...",
  partnerConnected: "Your partner successfully reconnected.",
  partnerLeft: "Your partner left the session.",
  partnerStuckAtLoading: "Your partner is trying to join the session, however is stuck at the loading screen.",

  NotAllowedError: "Please make sure your camera and microphone are connected and that the browser and Cofocus have permission to access them (mandatory). You may need to refresh the page after.",
  NotFoundError: "Please allow access to your camera and microphone to be able to use Cofocus. You may need to refresh the page after.",
  NotReadableError: "Cofocus was unable to access your camera or microphone. Please make sure another application or tab is not already using them. You may need to refresh the page after.",
  OverconstrainedError: "It seems your camera or microphone is no longer connected. Please reconnect the device to continue using Cofocus or connect another device.",
  TypeError: "Please make sure Cofocus is running on 'https://' (with the 's') and not 'http://'.",
};

// Synchronous
const mutations = {
  /* CORE ROOM STATE */
  RESET(state) {
    Object.assign(state, getDefaultState());
  },

  /* Used when user's own (LocalParticipant's) connection changes */
  SET_STATUS_MESSAGE(state, status) {
    if (status == "disconnected") {
      state.disconnected = true;
      state.reconnecting = false;
      state.connected = false;
    } else if (status == "reconnecting") {
      state.disconnected = false;
      state.reconnecting = true;
      state.connected = false;
    } else if (status == "connected") {
      state.disconnected = false;
      state.reconnecting = false;
      state.connected = true;
    }
    state.statusMessage = STATUS_MESSAGES[status];
    state.statusVisible = true;

    if (status == "connected") {
      setTimeout(() => {
        state.statusVisible = false;
        state.statusMessage = "";
      }, 3000);
    }
  },

  SET_STATUS_VISIBILITY(state, status) {
    state.statusVisible = status;
  },

  SET_INITIAL_STATE(state) {
    state.connected = true;
    state.statusVisible = false;
  },

  /* Used when a RemoteParticipant's connection state changes,
  to show the appropriate informational message to the user */
  SET_PARTNER_STATE(state, status) {
    if (status == "partnerDisconnected" && !state.partnerLeft) {
      state.partnerDisconnected = true;
      state.partnerReconnecting = false;
      state.partnerConnected = false;
      state.partnerStuckAtLoading = false;
    } else if (status == "partnerReconnecting") {
      state.partnerDisconnected = false;
      state.partnerReconnecting = true;
      state.partnerConnected = false;
      state.partnerLeft = false;
      state.partnerStuckAtLoading = false;
    } else if (status == "partnerConnected") {
      state.partnerDisconnected = false;
      state.partnerReconnecting = false;
      state.partnerConnected = true;
      state.partnerLeft = false;
      state.partnerStuckAtLoading = false;
    } else if (status == "partnerLeft") {
      state.partnerDisconnected = false;
      state.partnerReconnecting = false;
      state.partnerConnected = false;
      state.partnerLeft = true;
      state.partnerStuckAtLoading = false;
    } else if (status == "partnerStuckAtLoading") {
      state.partnerDisconnected = false;
      state.partnerReconnecting = false;
      state.partnerConnected = false;
      state.partnerLeft = false;
      state.partnerStuckAtLoading = true;
    }

    if (status == "partnerReconnecting" || status == "partnerConnected" || status == "partnerLeft" || status == "partnerStuckAtLoading") {
      state.partnerStatusMessage = STATUS_MESSAGES[status];
    } else if (status == "partnerDisconnected" && !state.partnerLeft) {
      state.partnerStatusMessage = STATUS_MESSAGES[status];
    }
    state.partnerStatusVisible = true;

    if (status == "partnerConnected") {
      setTimeout(() => {
        state.partnerStatusVisible = false;
        state.partnerStatusMessage = "";
      }, 2000);
    }
  },

  RESET_PARTNER_STATE(state) {
    state.partnerDisconnected = false;
    state.partnerReconnecting = false;
    state.partnerConnected = false;
    state.partnerStatusMessage = "";
    state.partnerStatusVisible = false;
  },
};

// Asynchronous
const actions = {
  /* CORE STATE */
  reset({ commit }) {
    commit("RESET");
  },

  setStatusMessage({ commit }, status) {
    commit("SET_STATUS_MESSAGE", status);
  },

  setStatusVisibility({ commit }, status) {
    commit("SET_STATUS_VISIBILITY", status);
  },

  setInitialState({ commit }) {
    commit("SET_INITIAL_STATE");
  },

  setPartnerState({ commit }, status) {
    commit("SET_PARTNER_STATE", status);
  },

  resetPartnerState({ commit }) {
    commit("RESET_PARTNER_STATE");
  },
};

const sessionState = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default sessionState;
